// eslint-disable-next-line import/no-cycle -- Already existing dependency cycle error, unsure how to fix
import MobileMenu from 'Components/Menu/MobileMenu';
// eslint-disable-next-line import/no-cycle -- Already existing dependency cycle error, unsure how to fix
import DesktopMenu from 'Components/Menu/DesktopMenu';
import './Menu.css';

type Props = {
    focus: boolean;
};

const Menu = (props: Props) => (
    <div>
        <span className="desktop-menu">
            <DesktopMenu />
        </span>
        {!props.focus && <MobileMenu />}
    </div>
);

export default Menu;
